import { useCallback, useEffect, useState } from "react";
export default function useIntersection(
  ref,
  { root = null, rootMargin = "0px", threshold = 0 } = {}
) {
  const [isIntersecting, setIsIntersecting] = useState(true);

  // Recalcul manuel basé sur getBoundingClientRect, en complément de
  // l'IntersectionObserver : sur certains iPad/Safari le callback de l'IO
  // ne se déclenche pas de façon fiable (observé aussi en tests), ce qui
  // bloquait le docking du header en position "visible" en permanence.
  const recompute = useCallback(() => {
    const el = ref?.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    const ratio = rect.height > 0 ? Math.max(0, visibleHeight) / rect.height : 0;
    setIsIntersecting(ratio >= threshold);
  }, [ref, threshold]);

  useEffect(() => {
    if (!ref?.current) return;
    const io = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting),
      { root, rootMargin, threshold }
    );
    io.observe(ref.current);

    recompute();
    window.addEventListener("scroll", recompute, { passive: true });
    window.addEventListener("resize", recompute);

    return () => {
      io.disconnect();
      window.removeEventListener("scroll", recompute);
      window.removeEventListener("resize", recompute);
    };
  }, [ref, root, rootMargin, threshold, recompute]);

  return isIntersecting;
}
